import React, { useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LoactionIcon from "assets/svgIcons/LocationArrow";
import ListIcon from "assets/svgIcons/ListIcon";
import ChangeIcon from "assets/svgIcons/ChangeIcon";
import { AccordionWrapper } from "commonComponents/CarDetails/AccordionDetails/AccordionDetailsStyled";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import TimeIcon from "assets/icons/time-icon.png";
import {
  UPDATED_CAR_DATA_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import _ from "lodash";
import { isCarInUse } from "_helperFunctions/isCarInUse";
import { isStale } from "_helperFunctions/isStale";
import { carType, isUserAdmin, isUserSupport } from "constant";
import { FaAddressCard } from "react-icons/fa";

export default function DetailAccordions(Props) {
  const { t } = useTranslation();
  const { isSiteUsingYards, convertMileToKM } = useCarSettingsData();
  const [expanded, setExpanded] = React.useState(false);
  const { carProductData, siteSettingsData, getUserRole, stagingModeData, getPackageManifestsData } = useSelector((state) => state.commonReducers) || [];
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  let LOCATION_BETWEEN_HOLES = 1;
  let LOCATION_TEE = 2;
  let LOCATION_FAIRWAY = 3;
  let LOCATION_GREEN = 4;

  let LOCATION_BETWEEN_HOLES_STR = "BetweenHoles";
  let LOCATION_TEE_STR = "Tee";
  let LOCATION_FAIRWAY_STR = "Fairway";
  let LOCATION_GREEN_STR = "Green";

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      GpsiCarId: Props?.gpsiCarId,
    };
    dispatch(COMMON_SERVICES.getProductData(payload));

    dispatch(COMMON_SERVICES.getPackageManifestsServices());
  }, [Props.gpsiCarId]);

  function renderCarName() {
    if (carProductData && carProductData.CarType === 0) {
      return <span className="card-view"></span>;
    } else if (carProductData && carProductData.CarType === carType.normal) {
      return <span className="card-view">{t("Fleet_car")}</span>;
    } else if (carProductData && carProductData.CarType === carType.marshal) {
      return <span className="card-view">Marshal car</span>;
    } else if (carProductData && carProductData.CarType === carType.handicap) {
      return <span className="card-view">{t("Special_needs_cars")}</span>;
    } else if (carProductData && carProductData.CarType === carType.bevcart) {
      return <span className="card-view">{t("Beverage_cars")}</span>;
    } else if (carProductData && carProductData.CarType === carType.outOfService) {
      return <span className="card-view">{t("Out_of_service")}</span>;
    } else if (carProductData && carProductData.CarType === carType.member && carProductData.SecondaryCarType === carType.handicap) {
      return <span className="card-view">{t("Member_/_Special_Needs")}</span>;
    } else if (carProductData && carProductData.CarType === carType.member) {
      return <span className="card-view">{t("Member_car")}</span>;
    } else if (carProductData && carProductData.CarType === carType.notInUse) {
      return <span className="card-view">Not in use car</span>;
    } else if (carProductData && carProductData.CarType === carType.notCommunicating) {
      return <span className="card-view">Not communicating car</span>;
    } else {
      return <span className="card-view">Car name not available</span>;
    }
  }

  function holeLocationString(x) {
    if (x === LOCATION_BETWEEN_HOLES || x === LOCATION_BETWEEN_HOLES_STR)
      return "Between Holes";
    else if (x === LOCATION_TEE || x === LOCATION_TEE_STR) return "Tee";
    else if (x === LOCATION_FAIRWAY || x === LOCATION_FAIRWAY_STR)
      return "Fairway";
    else if (x === LOCATION_GREEN || x === LOCATION_GREEN_STR) return "Green";
    else return "Unknown"; // "Unknown Hole Location";
  } // CarLocationInfo unsignedByte / CarDataHistoryInfo UlLocationReportReason

  function locationString() {
    const carsData =
      updatedCarData.get() && updatedCarData.get().length !== 0
        ? JSON.parse(updatedCarData.get())
        : [];

    const index = carsData.findIndex((v) => v?.Car?.CarNumber == Props.carNo);
    const carData = carsData[index];
    var result = "";
    if (
      carData?.Car.Course !== 0 &&
      carData?.Car.Hole !== 0 &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      result =
        carData?.Car.HoleLocation > 0
          ? holeLocationString(carData?.Car.HoleLocation)
          : "";
      var crs = _.find(siteSettingsData?.Courses, {
        Number: carData?.Car.Course,
      });
      result += crs ? " - " + crs.Name : "";
    }
    return result;
  }

  const getCarManifestText = () => {
    if (Props?.car.Car.PackageManifestId) {
      var manifest = getPackageManifestsData.find((m) => m.ManifestId == Props?.car.Car.PackageManifestId);

      if (!manifest && Props?.car.Car.PackageManifestId) {
        return '[' + carProductData.ManifestId + '] deleted?';
      }
      else {
        return (manifest) ? '[' + manifest.ManifestId + ']' + ' ' + manifest.ManifestDescription : 'none';
      }
    }

    return 'none';
  }

  return (
    <AccordionWrapper>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography>
            <LoactionIcon />
            {t("Location")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <tbody>
              {Props.ActionZoneId != 0 ? (
                <div>
                  {t("Action_Zone")} : {Props.ActionZoneLabel}
                </div>
              ) : (
                ""
              )}
              {t("Hole_No")}&nbsp;:&nbsp;
              {!isStale(Props?.car.Car) && isCarInUse(Props?.car.Car) && (
                <>
                  {Props?.holeNo}
                  {" " + locationString()}
                </>
              )}
              <br />
              {t("Last_updated")}: {Props?.update()}
              <p className="date-info">
                <img src={TimeIcon} alt="time-icon" />

                {Props?.lastupdate}
              </p>
            </tbody>
          </Typography>
        </AccordionDetails>
      </Accordion>
      {Props?.car?.Car?.CarType === carType.member && <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography>
            <FaAddressCard fill="#636F7C" size={20}/>
            {t("Member_Details")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <table className="w-100">
              <tbody>
                <tr>
                  <th colSpan={2} className="align-left">{t("First_Member")}
                  </th>

                </tr>
                <tr>
                  <td>{t("Name")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.MemberName}
                  </td>
                </tr>
                <tr>
                  <td>{t("Number")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.MemberNumber}
                  </td>
                </tr>
                <tr>
                  <td>{t("Email")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.EmailAddress}
                  </td>
                </tr>
              </tbody>
            </table>
            {Props?.car?.Members[0]?.MemberName2 && <table className="w-100">
              <tbody>
                <tr>
                  <th colSpan={2} className="align-left">{t("Second_Member")}
                  </th>

                </tr>
                <tr>
                  <td>{t("Name")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.MemberName2}
                  </td>
                </tr>
                <tr>
                  <td>{t("Number")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.MemberNumber2}
                  </td>
                </tr>
                <tr>
                  <td>{t("Email")}</td>
                  <td className="align-right">
                    {Props?.car?.Members[0]?.EmailAddress2}
                  </td>
                </tr>
              </tbody>
            </table>}
          </Typography>
        </AccordionDetails>
      </Accordion>}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography>
            <ListIcon />
            {t("Product_Details")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <table className="w-100">
              <tbody>
                <tr>
                  <td>{("Car_serial")} # </td>
                  <td className="align-right">
                    {carProductData && carProductData?.CarSerialNumber !== null
                      ? carProductData?.CarSerialNumber
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("Car_type")}</td>
                  <td className="align-right">{renderCarName()}</td>
                </tr>
                <tr>
                  <td>{t("Max_speed")}</td>
                  {stagingModeData && stagingModeData?.GuardianMode === 2 ? (
                    "0Mph"
                  ) : (
                    <td className="align-right">
                      {carProductData?.MaxSpeed === 0 || carProductData?.MaxSpeed === -1
                        ? t("Default")
                        : isSiteUsingYards()
                          ? carProductData?.MaxSpeed + "mph"
                          : Math.round(
                            convertMileToKM(carProductData?.MaxSpeed)
                          ) + "kph"}
                    </td>
                  )}
                </tr>
                <tr>
                  <td> {t("Controller")} #</td>
                  <td className="align-right">
                    {carProductData && carProductData?.ControllerModel !== null
                      ? carProductData?.ControllerModel
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("Odometer")}</td>
                  <td className="align-right">
                    {carProductData && carProductData?.Odometer} {t("Miles")}
                  </td>
                </tr>
                <tr>
                  <td>{t("Amp_Hours")}</td>
                  <td className="align-right">
                    {carProductData ? carProductData?.EnergyUnits : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("kW_Hours")}</td>
                  <td className="align-right">
                    {carProductData ? carProductData?.WattHours / 1000 : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("CC_Connect_Model")}</td>
                  <td className="align-right">
                    {carProductData && carProductData?.ControllerModel !== null
                      ? carProductData?.ControllerModel
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("CC_connect_serial")} #</td>
                  <td className="align-right">
                    {carProductData && carProductData?.CarSerialNumber !== null
                      ? carProductData?.CarSerialNumber
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{t("CC_connect_ID")} {t("(GPSI_Car_ID)")}</td>
                  <td className="align-right">
                    {carProductData && carProductData?.GpsiCarId}
                  </td>
                </tr>
                {(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) &&
                  <>
                    {carProductData && carProductData?.FusionVersions &&
                      <tr style={{ backgroundColor: "#c1e1e0", padding: 4 }}>
                        <td>VCM | MCU | BMS</td>
                        <td className="align-right">
                          {carProductData && carProductData?.FusionVersions}
                        </td>
                      </tr>
                    }
                    <tr style={{ backgroundColor: "#c1e1e0", padding: 4 }}>
                      <td>Manifest</td>
                      <td className="align-right">
                        {getCarManifestText()}
                      </td>
                    </tr>
                  </>
                }

                {carProductData &&
                  carProductData.length > 0 &&
                  carProductData.map((item, id) => {
                    return (
                      <tr key={item.GpsiCarId}>
                        <td>{item.GpsiCarId}</td>
                        <td>{item.CarType}</td>
                        <td>{item.MaxSpeed}</td>
                        <td>{item.MaxSpeed}</td>
                        <td>{item.Odometer}</td>
                        <td>{item.MaxSpeed}</td>
                        <td>{item.ControllerModel}</td>
                        <td>{item.CarSerialNumber}</td>
                        <td>{item.MaxSpeed}</td>
                        <td>{item.MaxSpeed}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography>
            <ChangeIcon />
            {t("Charge_History")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography></Typography>
        </AccordionDetails>
      </Accordion>
    </AccordionWrapper>
  );
}
